var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-cell',{attrs:{"title":"切换站点","value":_vm.city},on:{"click":function($event){return _vm.showCities()}}}),_c('Subsite',{ref:"subsite",attrs:{"siteDetail":_vm.city},on:{"onSelected":_vm.selectCity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }